function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Map } from 'immutable';
import { CHECKABLE_LIST_ITEM, UNORDERED_LIST_ITEM } from './constants'; // https://github.com/facebook/draft-js/blob/0.10-stable/src/model/immutable/DefaultDraftBlockRenderMap.js#L22
// <ul className={cx('public/DraftStyleDefault/ul')} />

var WRAPPER = React.createElement("ul", {
  className: "public-DraftStyleDefault-ul"
});
var blockRenderMap = Map(_defineProperty({}, CHECKABLE_LIST_ITEM, {
  element: 'li',
  wrapper: WRAPPER
}));
var blockRenderMapForSameWrapperAsUnorderedListItem = blockRenderMap.merge(Map(_defineProperty({}, UNORDERED_LIST_ITEM, {
  element: 'li',
  wrapper: WRAPPER
})));
export default blockRenderMap;
export { WRAPPER, blockRenderMapForSameWrapperAsUnorderedListItem };